import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import styles from '../../css/styling.module.css';
import { getActivityVideo, getActivityQuestionImage, getActivityVideo2 } from '../../../actions/activities_actions';
import Dropzone from "react-dropzone";
import YouTube from 'react-youtube';
import ReactPlayer from 'react-player';
import SecureLS from 'secure-ls';
import { sendActivityReplyAnswers, sendSharableSurveyReplyAnswers, getActivityReplyVideos, sendResponseVideoOnCloud } from '../../../actions/activities_reply_actions';
import axios from 'axios'
import { BACK_SERVER_URL } from '../../../config/server';
import { Line, Circle } from 'rc-progress';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";


const Question_With_Video2 = (props) => {

    const [videoUpload, setVideoUpload] = useState('')
    const [videoPreview, setVideoPreview] = useState(null);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [openModal, set_openModal] = useState(false)
    const [video_to_Confirm, set_video_to_confirm] = useState([])
    const toggle = () => set_openModal(!openModal);



    const uploadVideoToSpaces = (uploadUrl, file, setProgress) => {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();

            xhr.open("PUT", uploadUrl, true);

            // Use the actual MIME type
            xhr.setRequestHeader("Content-Type", file.type || "video/mp4");

            // Upload progress
            xhr.upload.onprogress = (event) => {
                if (event.lengthComputable) {
                    set_openModal(!openModal)
                    const percent = Math.round((event.loaded / event.total) * 100);
                    setProgress(percent);
                }
            };

            xhr.onload = () => {
                if (xhr.status >= 200 && xhr.status < 300) {
                    resolve(xhr.response);
                } else {
                    reject(new Error(`Upload failed with status ${xhr.status}`));
                }
            };

            xhr.onerror = () => reject(new Error("Network error during upload"));

            xhr.send(file);
        });
    }



    // On Video Select
    const onVideoSelect = async (file) => {

        if (file) {

            // Remove Error Message
            document.getElementById(`error-msg-${props.id}`).innerHTML = "";

            for (let i = 0; i < file.length; i++) {

                // File Extension Check
                const fileExtension = file[i].name
                    ? file[i].name.split(".").pop().toLowerCase()
                    : "mp4";

                if (fileExtension === "mp4") {

                    const filee = file[i];

                    const data = {
                        fileName: filee.name,
                        fileType: filee.type || "video/mp4",
                        fileDirectory: 'Replies',
                        activityId: params.surveyid || params.ActivityId || params.activityid,
                        userId: params.UserId ? params.UserId : props.userId
                    };

                    const response = await axios.post(
                        `${BACK_SERVER_URL}api/replies/presign`,
                        data
                    );

                    if (response && response.data && response.data.url) {
                        await uploadVideoToSpaces(
                            response.data.url,
                            filee,
                            setUploadProgress
                        );
                    }

                    // Better preview
                    setVideoPreview(URL.createObjectURL(filee));
                    setUploadProgress(0)




                    props.allContent.content[props.categoryIndex].questions[props.questionIndex].video = [response.data && response.data.key ? response.data.key : filee.name];
                    props.allContent.content[props.categoryIndex].questions[props.questionIndex].q = props.questionNo;

                    props.setContent({ ...props.allContent });
                    //console.log('props.allContent ->', props.allContent)

                }
            }


        }


        else {
            // console.log('else came here')
            document.getElementById(`error-msg-${props.id}`).innerHTML = `
                <div class="my-2">
                    <div class="alert alert-danger mb-0">
                        Invalid file type
                    </div>
                </div>
            `;
        }

    }


    // on Cancel Video
    const onCancelVideo = (index) => {
        props.allContent.content[props.categoryIndex].questions[props.questionIndex].video.splice(index, 1);
        props.setContent({ ...props.allContent });
        setVideoPreview(null)
        setUploadProgress(0)
    }

    // On Comment
    const onComment = (e) => {

        props.allContent.content[props.categoryIndex].questions[props.questionIndex].comment = e.target.value;
        props.setContent({ ...props.allContent });

    }
    const opts = {
        width: '640',
        height: '360',
        playerVars: {
            autoplay: 0
        },
    };
    const params = useParams();
    const userId = params.UserId
    const ls = new SecureLS()
    const user = ls.get('accessUser').user._id
    const catId = props.categoryId
    const questionIndex = props.questionIndex
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const [qVideo, setQVideo] = useState([])

    const [qImage, setQImage] = useState({})


    useEffect(() => {

        if (props.questionFile && props.questionFile !== '') {
            if (params.surveyid || params.ActivityId || params.activityid) {
                dispatch(getActivityVideo2(params.surveyid || params.ActivityId || params.activityid, catId, questionIndex))
                    .then((response) => {
                        try {
                            // console.log('question video in respodant side survey->', response.payload.content.fileData)
                            const fileData = response.payload.content.fileData;
                            setQVideo(Array.isArray(fileData) ? fileData : [fileData]);setQVideo(response.payload.content.fileData)
                        } catch (err) { console.log('video not available') }
                        setIsLoading(false);

                    })
                    .catch(err => err)
                // dispatch(getActivityQuestionImage(params.ActivityId || params.surveyid || params.activityid))
                //     .then((response) => {
                //         try {
                //             //console.log('question image in respondant side survey->', response.payload.content.fileData)
                //             setQImage(response.payload.content.fileData)
                //         } catch (err) { console.log('image in questionnaire not available') }
                //         setIsLoading(false);
                //     })
                //     .catch(err=>err)




            }
        }
        // else if (params.evaluationid) {
        //     dispatch(getActivityVideo(params.evaluationid))
        //         .then((response) => {
        //             try {
        //                // console.log('question video in respodant side survey->', response.payload.content.fileData)
        //                 setQVideo(response.payload.content.fileData)
        //             } catch (err) { console.log('video not available') }
        //             setIsLoading(false);

        //         })
        //         .catch(err=>err)
        //     dispatch(getActivityQuestionImage(params.evaluationid))
        //         .then((response) => {
        //             try {
        //                // console.log('question image long text in respondant side survey->', response.payload.content.fileData)
        //                 setQImage(response.payload.content.fileData)
        //             } catch (err) { console.log('image in questionnaire not available') }
        //             setIsLoading(false);
        //         })
        //         .catch(err=>err)


        // }
    }, []);








    const makeLinksOpenInNewTab = (htmlContent) => {
        // Create a DOM element to parse the HTML content
        const tempElement = document.createElement('div');
        tempElement.innerHTML = htmlContent;

        // Find all anchor tags within the parsed HTML content
        const anchorTags = tempElement.getElementsByTagName('a');

        // Iterate through the anchor tags and set the target attribute to '_blank'
        for (const anchorTag of anchorTags) {
            anchorTag.setAttribute('target', '_blank');
            // You can also set 'rel' attribute to 'noopener noreferrer' for security best practices
            anchorTag.setAttribute('rel', 'noopener noreferrer');
        }

        // Return the modified HTML content
        return tempElement.innerHTML;
    }


    const confirmVideoUpload = () => {

        return <Modal isOpen={openModal} toggle={toggle} id={`ImageModal`} className="modal-dialog-centered shadow-none" >
            <ModalHeader className="bg-white" toggle={toggle}>Are you sure you want to upload this video?</ModalHeader>
            <ModalBody className="text-center">

                <video width={300} controls className="img-fluid- border" style={{ maxHeight: 500 }}>
                    <source src={URL.createObjectURL(video_to_Confirm[0])} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={() => onVideoSelect(video_to_Confirm)}>
                    Yes
                </Button>
                <Button color="secondary" onClick={toggle}>
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    }




    return (
        <div className="my-3">
            <div className={styles.card_border} style={props.required && !props.isAnswered ? { borderColor: '#d92550' } : {}}>
                <div className={styles.card_border_body + " pt-4 pb-1"}>
                    <p style={{ color: '#666', fontSize: "1rem", fontWeight: '500', whiteSpace: 'pre-wrap' }} className="mb-0">

                        {/* Required check */}
                        {props.required &&
                            <span className="text-danger mr-1">*</span>
                        }

                        {/* Question text */}
                        {props.questionText &&
                            <span style={{ color: '#000', fontSize: '27px', fontWeight: '500' }} className='mb-0' dangerouslySetInnerHTML={{ __html: makeLinksOpenInNewTab(props.questionText) }} />
                        }

                        {/* Question YT video */}
                        {props.questionVideo && (
                            <div>

                                <YouTube videoId={props.questionVideo} opts={opts} className='py-4 text-center'></YouTube>

                            </div>
                        )}

                    </p>


                    {/* Question Video */}
                    {
                        props.questionFile && props.questionFile !== '' &&
                        <>
                            {
                                Array.isArray(qVideo) && qVideo.length > 0 ? (
                                    <div className="mx-3 mt-2 mb-4">
                                        <div className="pt-3 d-flex flex-wrap gap-3">
                                            {qVideo.map((file, index) => {
                                                const isVideo = file && file.type && file.type.includes('video');
                                                const src = file ? `data:${file.type};base64,${file.data}` : '';
                                                return file ? (
                                                    <div key={index} className="position-relative">
                                                        {isVideo ? (
                                                            <div style={{ maxWidth: '100%', overflow: 'hidden' }}>
                                                                <ReactPlayer url={src} controls width="100%" />
                                                            </div>
                                                        ) : (
                                                            <img
                                                                src={src}
                                                                className={`img-fluid border ${styles.banner_image}`}
                                                                style={{ borderRadius: '10px' }}
                                                                alt="img"
                                                            />
                                                        )}
                                                    </div>
                                                ) : null;
                                            })}
                                        </div>
                                    </div>
                                ) : isLoading ? (
                                    <div className="mx-3 mt-2 mb-4"><b>Loading Media...</b></div>
                                ) : null
                            }
                        </>
                    }


                    <div className="mt-3 mx-3">

                        {/* File Limit and File Size */}
                        <small className="text-danger">
                            Max files Limit: {props.filesLimit ? props.filesLimit : "1"} | Max file Size: {props.filesSize ? props.filesSize : "500"} MB
                        </small>

                        {/* Video Display & Dropzone  */}
                        {props.video && props.video.length > 0 ? (

                            // Video Display
                            <div className="row pt-3">

                                {props.video.map((videoSrc, index) => {
                                    return (
                                        <div key={index} className="position-relative mx-3 mb-3">
                                            <span className="questionVideo_close" style={{ marginLeft: '275px', zIndex: '2' }} onClick={() => onCancelVideo(index)}>&times;</span>

                                            {videoPreview && videoPreview != null &&
                                                <video width={300} controls className="img-fluid- border" style={{ maxHeight: 500 }}>
                                                    <source src={videoPreview} type="video/mp4" />
                                                    Your browser does not support the video tag.
                                                </video>
                                            }


                                        </div>
                                    )
                                })}

                            </div>


                        ) : (

                            // Video Drop Zone 
                            // < div className="dropzone-wrapper dropzone-wrapper-sm mb-3">
                            //     <Dropzone
                            //         maxFiles={!Number.isNaN(parseInt(props.filesLimit)) ? parseInt(props.filesLimit) : 0}
                            //         maxSize={!Number.isNaN(parseFloat(props.filesSize)) ? (parseFloat(props.filesSize) * 1048576) : (25 * 1048576)}
                            //         multiple={!Number.isNaN(parseInt(props.filesLimit)) ? (parseInt(props.filesLimit) > 0 ? true : false) : false}
                            //         accept={".mp4"}
                            //         onDrop={file => onVideoSelect(file)}

                            //     >
                            //         {({ getRootProps, getInputProps }) => (
                            //             <div {...getRootProps()}>
                            //                 <input {...getInputProps()} />
                            //                 <div className="dropzone-content" style={{ cursor: 'pointer' }}>

                            //                 {/* {videoPreview ? (
                            //     <video controls style={{ width: '100%', height: 'auto' }}>
                            //         <source src={videoPreview} type="video/mp4" />
                            //         Your browser does not support the video tag.
                            //     </video>
                            // ) : ( */}
                            //     <div className="d-flex">
                            //         <span className="pe-7s-video ml-1 mr-3" style={{ fontSize: "2rem", verticalAlign: "middle" }}></span>
                            //         <span className="text-left align-self-center" style={{ verticalAlign: "middle" }}>Click to select file to upload.</span>
                            //     </div>

                            //                     {/* <div className="d-flex">
                            //                         <span className="pe-7s-video ml-1 mr-3" style={{ fontSize: "2rem", verticalAlign: "middle" }}></span>
                            //                         <span className="text-left align-self-center" style={{ verticalAlign: "middle" }}>Click to select file to upload.</span>
                            //                     </div> */}
                            //                 </div>
                            //             </div>
                            //         )}
                            //     </Dropzone>
                            // </div>
                            <div className="dropzone-wrapper dropzone-wrapper-sm mb-3">

                                <Dropzone
                                    maxFiles={!Number.isNaN(parseInt(props.filesLimit))
                                        ? parseInt(props.filesLimit)
                                        : 0}

                                    maxSize={!Number.isNaN(parseFloat(props.filesSize))
                                        ? (parseFloat(props.filesSize) * 1048576)
                                        : (500 * 1048576)}

                                    multiple={!Number.isNaN(parseInt(props.filesLimit))
                                        ? (parseInt(props.filesLimit) > 0 ? true : false)
                                        : false}

                                    accept={".mp4"}

                                    onDrop={(file) => {

                                        set_openModal(true)
                                        set_video_to_confirm(file)

                                    }}
                                >

                                    {({ getRootProps, getInputProps }) => (

                                        <div {...getRootProps()}>

                                            <input {...getInputProps()} />

                                            <div
                                                className="dropzone-content"
                                                style={{
                                                    cursor: 'pointer',
                                                    minHeight: '140px',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center'
                                                }}
                                            >

                                                {/* SHOW PROGRESS */}
                                                {uploadProgress > 0 ? (

                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}
                                                    >

                                                        <div
                                                            style={{
                                                                width: '90px',
                                                                height: '90px',
                                                                position: 'relative'
                                                            }}
                                                        >
                                                            <Circle
                                                                percent={uploadProgress}
                                                                strokeWidth={10}
                                                                trailWidth={10}
                                                                trailColor='#E5E5E5'
                                                                strokeColor="#47B221"
                                                            />
                                                        </div>

                                                        <div
                                                            style={{
                                                                marginTop: '10px',
                                                                fontWeight: '600',
                                                                fontSize: '15px'
                                                            }}
                                                        >
                                                            Uploading... {uploadProgress}%
                                                        </div>

                                                    </div>

                                                ) : (

                                                    /* DEFAULT CONTENT */

                                                    <div className="d-flex">

                                                        <span
                                                            className="pe-7s-video ml-1 mr-3"
                                                            style={{
                                                                fontSize: "2rem",
                                                                verticalAlign: "middle"
                                                            }}
                                                        />

                                                        <span
                                                            className="text-left align-self-center"
                                                            style={{
                                                                verticalAlign: "middle"
                                                            }}
                                                        >
                                                            Click to select file to upload.
                                                        </span>

                                                    </div>

                                                )}

                                            </div>

                                        </div>

                                    )}

                                </Dropzone>

                            </div>

                        )}

                        {/* Text  Area */}
                        {/* <textarea id={props.id} className="form-control" placeholder="Write description here" value={props.answer} onChange={e => onChangeText(e.target.value)} /> */}

                        {openModal && confirmVideoUpload()}
                        {/* Comment */}
                        {props.isComment && (
                            <div className="form-group mt-1 mb-3">
                                <label>Comment</label>
                                <input className="form-control" type="text" value={props.comment} onChange={onComment} placeholder="Write here" />
                            </div>
                        )}

                    </div>

                    {/* Upload related error */}
                    <div id={`error-msg-${props.id}`}></div>

                    {/* Required Answer error */}
                    {/* {props.required && !props.isAnswered && (
                        <div id={`error-msg`}>
                            <div className="my-2">
                                <div className="alert alert-danger mb-0">
                                    Please answer this question.
                                </div>
                            </div>
                        </div>
                    )} */}


                </div>
            </div>
        </div >
    )

}

export default Question_With_Video2;